import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  remainingSeconds: number;
  onContinue: () => void;
  onSignOut: () => void;
}

export function SessionIdleModal({ open, remainingSeconds, onContinue, onSignOut }: Props) {
  const { t } = useTranslation();
  const titleId = 'session-idle-title';
  const descriptionId = 'session-idle-description';

  return (
    <Modal
      show={open}
      backdrop="static"
      keyboard={false}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <Modal.Header>
        <Modal.Title id={titleId}>{t('common.dialog.warning-title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body id={descriptionId}>
        <p>{t('common.messages.warningInactiveSession')}</p>
        <p aria-live="polite">
          {t('common.messages.sessionIdleCountdown', { count: remainingSeconds })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onSignOut}>
          {t('common.label.logout')}
        </Button>
        <Button variant="primary" onClick={onContinue}>
          {t('common.button.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
